import request from "@/utils/request";
import { setToken } from "../utils/auth";
import { jsonp } from "vue-jsonp";
// 获取用户信息
export function getInfo(token) {
  return new Promise((resolve) => {
    // //console.log(333333333333333);
    // $.ajax({
    //   // url: "//d.drcnet.com.cn/eDRCnet.common.web/login/login.ashx?flag=initp", //initp 查询目前用户登录状态，logoutp 退出登录
    //   url: "http://user.drcnet.com.cn/userapi/loginController/initLoginP?flag=initp", //本地登录替换，http的登录
    //   type: "get",
    //   dataType: "jsonp", //指定服务器返回的数据类型
    //   jsonpCallback: "showData", //指定回调函数名称
    //   xhrFields: { withCredentials: true },
    //   crossDomain: true,
    //   async: true,
    //   success: function (data) {
    //     //console.log(data);
    //     if (data.UserToken) {
    //       setToken(data.UserToken);
    //       request({
    //         url: "/common/unAuth/getUserInfoByToken/" + data.UserToken,
    //         method: "get",
    //       }).then((res) => resolve(res));
    //     } else {
    //       resolve({});
    //     }
    //   },
    //   error: function (xhr, status, error) {
    //     //console.log(11111111111111111111);
    //     // 请求失败后的回调函数
    //     //console.log(status, error);
    //     resolve({});
    //   },
    // });
    ////d.drcnet.com.cn/eDRCnet.common.web/login/login.ashx?flag=initp
    let loginUrl =
      "http://user.drcnet.com.cn/userapi/loginController/initLoginP";
    jsonp(loginUrl, {
      flag: "initp",
      callbackName: "showData",
    })
      .then((res) => {
        //console.log(res);
        if (res.UserToken) {
          setToken(res.UserToken);
          request({
            url: "/common/unAuth/getUserInfoByToken/" + res.UserToken,
            method: "get",
          })
            .then((res) => {
              resolve(res);
              //console.log(res);
            })
            .catch((err) => {
              // //console.log(err);
              resolve({});
            });
        } else {
          resolve({});
        }
      })
      .catch((err) => {
        // //console.log(err);
        resolve({});
      });
  });
}
